import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

/* Layout */
import Layout from "@/layout";
import userRouter from "./modules/user";
import otherRouter from "./modules/other";
import logsRouter from "./modules/logs";
/**
 * 基础路由
 */
export const constantRoutes = [
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path(.*)",
        component: () => import("@/views/redirect/index"),
      },
    ],
  },
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
  {
    path: "/404",
    component: () => import("@/views/error-page/404"),
    hidden: true,
  },
  {
    path: "/401",
    component: () => import("@/views/error-page/401"),
    hidden: true,
  },
  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        component: () => import("@/views/dashboard/index"),
        name: "Dashboard",
        meta: { title: "首页", icon: "el-icon-house", affix: true },
      },
    ],
  },
  // {
  //   path: "/dashboard2",
  //   component: Layout,
  //   redirect: "/dashboard2",
  //   children: [
  //     {
  //       path: "dashboard2",
  //       component: () => import("@/views/dashboard/index2"),
  //       name: "Dashboard2",
  //       meta: { title: "首页2", icon: "el-icon-house", affix: true },
  //     },
  //   ],
  // },
];

/**
 * 业务路由
 */
export const asyncRoutes = [
  userRouter,
  otherRouter,
  logsRouter,
  // 404 page must be placed at the end !!!
  { path: "*", redirect: "/404", hidden: true },
];

const createRouter = () =>
  new Router({
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
